import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import { ColumnConfig } from '@/components/table/Table';
import { formatDate } from '@/utils/dates';

type AmendmentsTableColumnsHandlers = {
  onSelectReason: (reason: string) => void;
  shippingBaseUrl?: string;
};

export const getAmendmentsTableColumns = ({
  onSelectReason,
  shippingBaseUrl = '/business/shipping',
}: AmendmentsTableColumnsHandlers): ColumnConfig[] => [
  {
    label: 'ID Pedido',
    field: 'shippingNumber',
    render: (value: number) => (
      <a
        href={`${shippingBaseUrl}/${value}`}
        target='_blank'
        rel='noreferrer'
        className='inline-flex items-center gap-1 text-blue-600 hover:underline'
        onClick={(e) => e.stopPropagation()}
      >
        <OpenInNewIcon sx={{ fontSize: 14 }} />
        {value ?? 'N/A'}
      </a>
    ),
  },
  {
    label: 'Motivo',
    field: 'reason',
    render: (value: string) => (
      <button
        className='text-sm text-left truncate block max-w-[450px] hover:underline cursor-pointer'
        onClick={() => onSelectReason(value || 'N/A')}
      >
        {value || 'N/A'}
      </button>
    ),
  },
  {
    label: 'Estado anterior',
    field: 'fromStatus',
    render: (value: { commercialName: string } | undefined) =>
      value?.commercialName ?? 'N/A',
  },
  {
    label: 'Estado resultante',
    field: 'toStatus',
    render: (value: { commercialName: string } | undefined) =>
      value?.commercialName ?? 'N/A',
  },
  {
    label: 'Aplicado por',
    field: 'appliedBy',
    render: (value: string) => value || 'N/A',
  },
  {
    label: 'Fecha',
    field: 'createdAt',
    sortable: true,
    render: (value: string) => formatDate(value),
  },
];
